import React, { FC } from 'react';
import classNames from 'classnames';

interface Props {
  elementClass?: string;
}

const IconBluesky: FC<Props> = (props) => {
  const classes = classNames('icon', 'icon-bluesky', props.elementClass);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      className={classes}
    >
      <title>Bluesky</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5 10.8c-1.087-2.114-4.046-6.053-6.798-7.995C4.388 1.143 2-.539 2 3.503c0 .873.5 7.317.794 8.368.667 2.319 3.594 2.984 6.199 2.575-4.511.779-5.503 3.374-3.003 5.966 1.105 1.14 2.214 1.728 3.31 1.728 1.125 0 2.242-.607 3.31-1.728.614-.634 1.039-1.266 1.39-1.828.35.562.775 1.194 1.39 1.828 1.068 1.121 2.185 1.728 3.31 1.728 1.096 0 2.205-.588 3.31-1.728 2.5-2.592 1.508-5.187-3.003-5.966 2.605.409 5.532-.256 6.199-2.575.294-1.051.794-7.495.794-8.368 0-4.042-2.388-2.36-3.702-1.695C16.546 4.747 13.587 8.686 12.5 10.8z"
        fill="currentColor"
      />
    </svg>
  );
};

export default IconBluesky;
